/**
 * Centralised HTTP client with consistent CSRF protection headers.
 */
import ky from "ky";

const httpClient = ky.create({
  headers: {
    "X-Widget-Request": "true",
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 30000,
  retry: {
    limit: 0,
  },
});

export const apiClient = {
  get: <T = unknown>(url: string, options?: Parameters<typeof httpClient.get>[1]) =>
    httpClient.get(url, options).json<T>(),

  post: <T = unknown>(
    url: string,
    data?: unknown,
    options?: Parameters<typeof httpClient.post>[1],
  ) =>
    httpClient
      .post(url, {
        ...options,
        json: data,
      })
      .json<T>(),

  put: <T = unknown>(url: string, data?: unknown, options?: Parameters<typeof httpClient.put>[1]) =>
    httpClient
      .put(url, {
        ...options,
        json: data,
      })
      .json<T>(),

  patch: <T = unknown>(
    url: string,
    data?: unknown,
    options?: Parameters<typeof httpClient.patch>[1],
  ) =>
    httpClient
      .patch(url, {
        ...options,
        json: data,
      })
      .json<T>(),

  delete: <T = unknown>(url: string, options?: Parameters<typeof httpClient.delete>[1]) =>
    httpClient.delete(url, options).json<T>(),
} as const;
